import { useReactiveVar } from '@apollo/client';
import { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { longIdle } from '../env';
import Button from '../../components/common/button';

const SessionTimeout = (props: any) => {
   
    const [modalOpen, setModalOpen] = useState<boolean>(false)

    const idle = useReactiveVar(longIdle)

    useEffect(() => {
        if (idle > 0) {
            setModalOpen(true)
        }
    }, [idle])

    const toggle = () => {
        setModalOpen(!modalOpen)
        window.location.reload()
    }

    return (
        <Modal role="alertdialog" style={{maxWidth: '600px'}} isOpen={modalOpen} backdrop="static" autoFocus={false}>
            <ModalHeader tag={'h2'} cssModule={{'modal-title': 'w-100 text-center'}}>Session expired</ModalHeader>
            <ModalBody className="centered-content">  
                Your session has expired.<br/> You will have to refresh your browser to start a new session.
            </ModalBody>
            <ModalFooter>
                <Button onClick={toggle} autoFocus={true}>Refresh</Button>
            </ModalFooter>
        </Modal>
    )
} 

export default SessionTimeout;